'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var selectionArea = document.querySelector('.facet-selected-list');
    if (!selectionArea) return;

    try {
        selectionArea.innerHTML = '';
        var authorsSerializedKey = _storageProvider2.default.sharedKeys.authorsSerializedKey;
        var authorsSerialized = _storageProvider2.default.getValueSession(authorsSerializedKey);

        var facetsStore = _common2.default.getFacetsFromStore();
        if (!!authorsSerialized) {
            facetsStore.groups.push(authorsSerialized);
        }

        var allSelectedFilters = _common2.default.loadObjectFilter();

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var group = _step.value;

                // categories won't be enlisted on selected filters pane for now
                var groupName = group.name.toLowerCase();
                if (groupName === 'categories') return 'continue';

                var itemValues = [].concat((0, _toConsumableArray3.default)(group.items));
                var selectedFiltersGr = allSelectedFilters ? allSelectedFilters[group.name] || [] : [];

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(itemValues), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var facetItem = _step2.value;

                        var facVal = facetItem.value.toString();

                        if (groupName === 'authors') facetItem.checked = selectedFiltersGr.indexOf(facVal) > -1;

                        if (!facetItem.checked) continue;

                        var selectedFilterButton = _common2.default.createElement('a', selectionArea, {
                            className: 'facet-clear__btn'
                        });
                        selectedFilterButton.addEventListener('click', function (event) {
                            selectedFilterClick(event, itemValues);
                        });
                        selectedFilterButton.dataset.filterValue = facetItem.value;
                        selectedFilterButton.dataset.groupName = group.name;
                        _common2.default.createElement('i', selectedFilterButton, { className: 'icon-delete' });
                        _common2.default.createElement('span', selectedFilterButton, { textContent: facetItem.displayName });
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            };

            for (var _iterator = (0, _getIterator3.default)(facetsStore.groups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ret = _loop();

                if (_ret === 'continue') continue;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var filterObject = _common2.default.loadObjectFilter();
        if (filterObject) {
            createButtonWithLocalDate(filterObject.ReleaseFrom, 'ReleaseFrom');
            createButtonWithLocalDate(filterObject.ReleaseTo, 'ReleaseTo');

            createAvailabilityButton(filterObject, 'AvailabilityOperator', 'AvailabilityValue', Resx.App.StockAvailabilityGrada);
            createAvailabilityButton(filterObject, 'CustomAvailabilityOperator', 'CustomAvailabilityValue', Resx.App.MyStockAvailability);
        }
    } catch (e) {
        console.error('Error in Facet Selected Pane building', e);
    }

    function createAvailabilityButton(filterObject, operatorProperty, valueProperty, prefixText) {
        if (!_common2.default.testIntInString(filterObject[operatorProperty]) || !_common2.default.testIntInString(filterObject[valueProperty])) return;

        var operator = parseInt(filterObject[operatorProperty]);
        var operatorValue = parseInt(filterObject[valueProperty]);

        if (operator <= 0) return;

        createAppliedFilterButton(prefixText + ' (' + getOperatorSymbol(operator) + ' ' + operatorValue + ')', operatorProperty, valueProperty);
    }

    function createButtonWithLocalDate(dateString, filterType) {
        if (!dateString) return;

        try {
            var date = new Date(dateString);
            var operator = filterType === 'ReleaseFrom' ? '>' : '<';
            createAppliedFilterButton(Resx.Common.DateRelease + ': ' + operator + ' ' + date.toLocaleDateString(), filterType);
        } catch (e) {
            console.error('Error in creating applied filter button type: ' + filterType, e);
        }
    }

    function createAppliedFilterButton(title, filterType, filterTypeSecondary) {
        var selectedFilterButton = _common2.default.createElement('a', selectionArea, {
            className: 'facet-clear__btn'
        });
        selectedFilterButton.dataset.filterType = filterType;
        selectedFilterButton.dataset.filterTypeSecondary = filterTypeSecondary;
        selectedFilterButton.addEventListener('click', function (event) {
            var filterObject = _common2.default.loadObjectFilter();
            delete filterObject[event.target.dataset.filterType];
            delete filterObject[selectedFilterButton.dataset.filterTypeSecondary];
            var url = _common2.default.setupUpdateSearchUrlByObject(filterObject);
            _common2.default.updateSearchQueryByUrl(url);
        });
        _common2.default.createElement('i', selectedFilterButton, { className: 'icon-delete' });
        _common2.default.createElement('span', selectedFilterButton, { textContent: title });
    }

    function selectedFilterClick(event, itemValues) {
        var button = event.target;
        var filterValue = button.dataset.filterValue;

        var newlyDisplayedValues = [].concat((0, _toConsumableArray3.default)(itemValues.filter(function (iv) {
            return (iv.value || '').toString() !== filterValue && iv.checked;
        }))).map(function (m) {
            return m.value;
        });

        var groupName = button.dataset.groupName;
        var filterRegex = _common2.default.getFilterParamRegex(groupName);
        _common2.default.updateSearchQuery(filterRegex, newlyDisplayedValues, groupName);
    }

    function getOperatorSymbol(operatorValue) {
        var operatorSymbol = '';

        if (operatorValue & 1) operatorSymbol += '>';
        if (operatorValue & 2) operatorSymbol += '<';
        if (operatorValue & 4) operatorSymbol += '=';

        return operatorSymbol;
    }
};

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

var _storageProvider = require('../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/facetSelectedPane.js
// module id = 939
// module chunks = 0